import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { ArrowLeftIcon } from '@heroicons/react/24/outline'; // Assuming you use Heroicons for the icon

// Assuming 'onClose' is a prop to close a modal/dialog if this button is inside one.
// If this button is NOT inside a modal/dialog, you can remove the 'onClose' prop from here.
const GoBackButton = ({ onClose }: { onClose?: () => void }) => {
  const navigate = useNavigate(); // Initialize the navigate hook

  const handleGoBack = () => {
    if (onClose) {
      onClose(); // First, close any open dialog/modal if applicable
    }
    navigate(-1);
  };

  return (
    <button
      className="flex items-center gap-2 !mb-2"
      onClick={handleGoBack} // Call our new handler
    >
      <ArrowLeftIcon width={24} height={24} color="#666D80" />
      <p className="!text-sm text-[#666d80]">Go Back</p>
    </button>
  );
};

export default GoBackButton;